import './TimePeriodIndicator.scss';

export default function TimePeriodIndicator({ minDate, maxDate, fromDate, toDate, contractDuration }: { minDate: Date, maxDate: Date, fromDate: Date, toDate: Date, contractDuration: number }) {
  
  const totalDuration = maxDate.getTime() - minDate.getTime();

  // Clamp fromDate and toDate to within minDate and maxDate
  const clampedFrom = new Date(Math.max(minDate.getTime(), fromDate.getTime()));
  const clampedTo = new Date(Math.min(maxDate.getTime(), toDate.getTime()));

  const startOffset = clampedFrom.getTime() - minDate.getTime();
  const spanDuration = Math.max(clampedTo.getTime() - clampedFrom.getTime(), 0);

  const left = (startOffset / totalDuration) * 100;
  const width = (spanDuration / totalDuration) * 100;

  const todayLeft = (new Date().getTime() - minDate.getTime()) / totalDuration * 100;

  const ellapsedDuration = new Date().getTime() - clampedFrom.getTime();
  const ellapsedDurationPercentage = Math.round((ellapsedDuration / spanDuration) * 100);
  const remainingDurationPercentage = 100 - ellapsedDurationPercentage;

  const tooltipHtml = ellapsedDuration > 0
    ? `<div>Effective: ${fromDate.toLocaleDateString()}</div><div>Ends: ${toDate.toLocaleDateString()}</div><div>The contract is for ${contractDuration} years</div><div>${ellapsedDurationPercentage}% of the contract has elapsed</div><div>${remainingDurationPercentage}% of the contract remains</div>`
    : `<div>Effective: ${fromDate.toLocaleDateString()}</div><div>Ends: ${toDate.toLocaleDateString()}</div><div>The contract is for ${contractDuration} years</div>`

  return (
    <div className="time-period-indicator">
      <div
        className="time-period-indicator-bar"
        style={{ left: `${left}%`, width: `${width}%` }}
        data-tooltip-html={tooltipHtml}
        data-tooltip-id="main-tooltip"
      />
      <div className="today-indicator"
        style={{ left: `${todayLeft}%` }}
        data-tooltip-id="main-tooltip"
        data-tooltip-html={`<div>Today</div>`}
      />
    </div>
  );
}
